import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { reactive, onMounted, toRefs, defineComponent } from "vue";
import apis from "@/api";
import ProcessInfo from "./ProcessInfo.vue";
import { USERINFO } from "@/store/mutation-types";
export default defineComponent({
  components: {
    ProcessInfo
  },
  setup() {
    onMounted(() => {
      const user = window.localStorage.getItem(USERINFO);
      data.userInfo = JSON.parse(user);
      // data.queryParam.empId = "taoyanbo";
      data.queryParam.empId = data.userInfo.userEmpNo;
      loadData();
    });
    let data = reactive({
      userInfo: {},
      loading: true,
      dialogFormVisible: false,
      dialogFormEditable: false,
      currentProcess: {},
      activeName: "0",
      processList: [],
      paginationObj: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      queryParam: {
        demandName: "",
        userName: "",
        empId: ""
      }
    });
    const demandType = row => {
      switch (row.demandType) {
        case 0:
          return '设计需求';
        case 1:
          return '短信需求';
        case 3:
          return '投放监测';
        default:
          return '设计需求';
      }
    };
    const loadData = () => {
      data.loading = true;
      data.processList = [];
      data.queryParam.status = data.activeName;
      const param = {
        ...data.queryParam,
        ...data.paginationObj
      };
      apis.getProcessList(param).then(res => {
        if (res.success) {
          var _res$data;
          const {
            records,
            size,
            total,
            current
          } = (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : res.data = {};
          data.processList = records !== null && records !== void 0 ? records : [];
          data.paginationObj = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).finally(() => {
        data.loading = false;
      });
    };
    const handleClick = (tab, event) => {
      data.queryParam.status = tab.props.name;
      loadData();
    };
    const handleSizeChange = val => {
      data.paginationObj.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.paginationObj.pageNo = val;
      loadData();
    };
    const query = () => {
      loadData();
    };
    const reset = () => {
      data.queryParam = {
        status: "0",
        demandName: "",
        userName: "",
        empId: data.userInfo.userEmpNo
      };
      loadData();
    };
    const handleView = row => {
      data.currentProcess = row;
      data.dialogFormEditable = false;
      data.dialogFormVisible = true;
    };
    const handleAudit = row => {
      data.currentProcess = row;
      data.dialogFormEditable = true;
      data.dialogFormVisible = true;
    };
    const handleCancel = () => {
      data.dialogFormVisible = false;
    };
    const handleSubmit = params => {
      apis.processHandle(params).then(res => {
        if (res.success) {
          ElMessage.success(res.msg);
          data.dialogFormVisible = false;
          loadData();
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    return {
      ...toRefs(data),
      demandType,
      handleClick,
      handleSizeChange,
      handleCurrentChange,
      handleView,
      handleAudit,
      handleCancel,
      handleSubmit,
      query,
      reset
    };
  }
});